import { Tab, Tabs, Box } from "@mui/material";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useAppSelector } from "redux/hooks";
import { selectCollectEnabled, selectIsAdmin, selectIsOwner } from "redux/slices/session";

const Users = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isOwner = useAppSelector(selectIsOwner);
  const isAdmin = useAppSelector(selectIsAdmin);
  const collectEnabled = useAppSelector(selectCollectEnabled);

  const showTabBar = () => {
    if (
      (isOwner || isAdmin) &&
      collectEnabled &&
      (location.pathname === "/users/pattern" || location.pathname === "/users/collect")
    ) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}>
      {showTabBar() && (
        <Box
          sx={{
            mb: 2,
          }}>
          <Tabs value={location.pathname.split("/").pop()}>
            <Tab value="pattern" label="Pattern" onClick={() => navigate("pattern")} />
            <Tab value="collect" label="Collect" onClick={() => navigate("collect")} />
          </Tabs>
        </Box>
      )}
      <Box
        sx={{
          // fill remaining space
          // max height of remaining space
          height: "100%",
        }}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default Users;
